import React from 'react';
import { Page } from '../Page';
export function PageGutSide() {
  return <Page pageNumber={3} variant="light" data-id="element-1424" data-mp="3n3szygfkf8sz">
      <div className="flex flex-col h-full" data-id="element-1425" data-mp="3n2rmk5b2ua83">
        <div className="mb-8 pt-4" data-id="element-1426" data-mp="3n5mc2b8y6l8d">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1427" data-mp="3s2mfeeeex9vs">
            Understanding Your Medication
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1428" data-mp="uible1wu91q">
            GLP-1 And <span className="text-tealslate" data-id="element-1429" data-mp="2zg1mvam7arqn">The Gut</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate mb-4" data-id="element-1430" data-mp="34e37hzz9yz48" />
          <p className="text-sm text-[#3B3B3B] leading-[1.8] max-w-md" data-id="element-1431" data-mp="39co9a3u6dqus">
            The physical changes to your digestion that create lasting fullness.
          </p>
        </div>

        <p className="text-[10px] text-[#7A7A70] tracking-wider font-bold mb-1" data-id="element-1432" data-mp="3e4xwhc3woctd">
          <em data-id="element-1433" data-mp="2gnh26ggnnsxx">Figure 1</em>
        </p>
        <div className="flex-1 -mx-12 px-12 flex flex-col justify-center" data-id="element-1434" data-mp="2lmk8e48dg57h">
          <div className="flex justify-center" data-id="element-1435" data-mp="2lkh5ijm4ehlc">
            <img src="https://cdn.magicpatterns.com/uploads/dysD2x9V1S39AoBcTvTWYN/Picture1.png" alt="Digestive system diagram showing how food stretches the stomach and activates stretch receptors" className="h-[637px] object-contain" data-id="element-1436" data-mp="zs9iqdf2tfpv" />
          </div>
        </div>

        <div className="pt-6" data-id="element-1437" data-mp="l3vhu81801by">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1438" data-mp="l2kda5zyapjs">
            <strong className="text-[#1F1F1F]" data-id="element-1439" data-mp="h4edjhxj5a8d">How it works:</strong>{' '}
            <em data-id="element-1440" data-mp="c3gtezsym648">
              The medication slows the release of food from your stomach into
              the intestine. As food sits longer, stretch receptors fire and
              tell your brain you're full. The result: smaller portions feel
              like enough.
            </em>
          </p>
        </div>
      </div>
    </Page>;
}